module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.showHeaderBar) { ;
__p += '\n    <div class="headerBar"></div>\n';
 } ;
__p += '\n<div id="page-content"></div>\n';
return __p
}